export class ImpersonationStateSet {
  public static readonly type = '[Impersonation] Set';

  constructor(
    public kundeID: number,
    public kundeName: string,
  ) {}
}

/**
 * Ends the impersonation and resets the state to its defaults.
 */
export class ImpersonationStateClear {
  public static readonly type = '[Impersonation] Clear';
}
